import { useNavigate, useParams } from "react-router-dom";

interface LogoProps {
    logo: {
        img: string;
        size: number;
        label: string;
    };
}

export const Logo: React.FC<LogoProps> = ({ logo }) => {
    const navigate = useNavigate();
    const { account, msp } = useParams();

    const basePath = `/X7pL9q${account ? `/${account}${msp ? `/${msp}` : ''}` : ''}`;

    return (
        <div
            className="absolute top-[24px] left-[24px] cursor-pointer"
            onClick={() => navigate(basePath)}
        >
            <span style={{
                color: '#22FFAF',
                fontSize: 18,
                fontWeight: 800,
                fontFamily: "'Nunito Sans', sans-serif",
                letterSpacing: 0.5,
            }}>
                Breacher.ai
            </span>
        </div>
    );
};
